import { Box } from '@mui/material'

/**
 * GOVIA — Isotipo oficial (UX-9 Brand Phase A).
 *
 * PROVISIONAL BRAND ASSET — HUMAN VISUAL APPROVAL REQUIRED. Reemplaza el
 * placeholder anterior (hexágono + puntos de esquina, colores `#4C6FFF`/
 * `#22D3EE`/`#0B1120` — ninguno de los 6 hex oficiales de la marca) por
 * una interpretación geométrica del isotipo de referencia: un anillo
 * abierto ("C") + espolón horizontal (la barra que lo convierte en "G")
 * + punta en bandera en el extremo superior (el pliegue/cinta de la
 * referencia). Misma geometría exacta que `public/brand/govia-isotipo.svg`
 * — ambos archivos deben mantenerse idénticos (criterio PASS de
 * `GOVIA_UX9_BRAND_PHASE_A_PLAN.md` §6: "nunca redibujado distinto entre
 * pantallas").
 *
 * Colores: únicamente los oficiales de `v2/theme.ts::OFFICIAL`
 * (`#2563FF` -> `#00C2FF`) — deliberadamente hardcodeados aquí (no
 * importados de `v2/design-system/tokens.ts`, que es exclusivo del tema
 * V2): este componente lo consumen V1, V2 y Super Admin por igual, y una
 * marca no debe variar según el tema que la rodea.
 *
 * Sin fondo (transparente) — es el isotipo "standalone" (referencia
 * "02 STANDALONE ISOTIPO"). El fondo navy con esquinas redondeadas es
 * exclusivo de favicon/app-icon (referencias "07"/"08"), nunca de este
 * componente, que siempre se usa incrustado sobre un fondo ya oscuro
 * (sidebar, panel de login) — duplicar un fondo propio se vería como una
 * tarjeta dentro de otra tarjeta.
 *
 * API sin cambios: mismo prop `size` (default 28), mismo `viewBox`, mismo
 * `aria-hidden` — los 4 consumidores existentes (Sidebar V1, SidebarV2,
 * LoginPage, AuthLayout) heredan el isotipo nuevo sin ninguna línea
 * propia modificada.
 */
export function BrandMark({ size = 28 }: { size?: number }) {
  return (
    <Box
      component="svg"
      viewBox="0 0 64 64"
      sx={{ width: size, height: size, flexShrink: 0 }}
      aria-hidden
    >
      <defs>
        <linearGradient id="govia-brand-gradient" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#2563FF" />
          <stop offset="1" stopColor="#00C2FF" />
        </linearGradient>
      </defs>
      <path
        fill="url(#govia-brand-gradient)"
        d="M52,44.5 A23,23 0 1,1 52,21.5 L60,13 L44,26 A14,14 0 1,0 44,40 L52,44.5 Z"
      />
      <rect x="28" y="29" width="20" height="8" rx="1" fill="url(#govia-brand-gradient)" />
    </Box>
  )
}
